// extracted by mini-css-extract-plugin
module.exports = {"carouselBase":"styles_carouselBase__DAHDM","carousel":"styles_carousel__lKOFt","pagination":"styles_pagination__5uM5L"};